// Aditya Lens is NOT part of the current Aditya Labs AI-agent private pilot.
// Lens routes render an out-of-scope notice unless Lens is explicitly enabled
// via this flag. Default is OFF (out of scope).
export function isLensLaunchEnabled(
  flag = process.env.NEXT_PUBLIC_LENS_LAUNCH_ENABLED
): boolean {
  return flag === "true";
}
